export class PWAInstallService {
  private static deferredPrompt: any = null;
  private static listeners: ((canInstall: boolean) => void)[] = [];

  static init() {
    if (typeof window !== 'undefined') {
      window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        // Stash the event so it can be triggered later.
        this.deferredPrompt = e;
        this.notifyListeners(true);
      });

      window.addEventListener('appinstalled', () => {
        this.deferredPrompt = null;
        this.notifyListeners(false);
        console.log('[PWAInstallService] YamooPay successfully installed as standalone PWA');
      });
    }
  }

  static isStandalone(): boolean {
    if (typeof window === 'undefined') return false;
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone === true ||
      document.referrer.includes('android-app://')
    );
  }

  static isInstallEligible(): boolean {
    return this.deferredPrompt !== null;
  }

  static isIOS(): boolean {
    if (typeof navigator === 'undefined') return false;
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  }

  static async promptInstall(): Promise<'ACCEPTED' | 'DISMISSED' | 'UNAVAILABLE'> {
    if (!this.deferredPrompt) {
      return 'UNAVAILABLE';
    }

    try {
      this.deferredPrompt.prompt();
      const { outcome } = await this.deferredPrompt.userChoice;
      this.deferredPrompt = null;
      this.notifyListeners(false);
      return outcome === 'accepted' ? 'ACCEPTED' : 'DISMISSED';
    } catch (e) {
      console.warn('[PWAInstallService] Prompt error:', e);
      return 'UNAVAILABLE';
    }
  }

  static subscribe(callback: (canInstall: boolean) => void): () => void {
    this.listeners.push(callback);
    callback(this.isInstallEligible());
    return () => {
      this.listeners = this.listeners.filter((l) => l !== callback);
    };
  }

  private static notifyListeners(canInstall: boolean) {
    this.listeners.forEach((l) => l(canInstall));
  }
}

// Automatically initialize listener in browser environment
PWAInstallService.init();
